<template>
<div>
    <div class="d-flex flex-column-fluid">
        <!--begin::Container-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="row">
                        <div class="col-lg-12 col-xl-12">
                            <div class="card card-custom gutter-b bg-transparent shadow-none border-0">
                                <div class="card-header align-items-center  border-bottom-dark px-0">
                                    <div class="card-title mb-0">
                                        <h3 class="card-label mb-0 font-weight-bold text-body">
                                            Коллекции товаров
                                        </h3>
                                    </div>
                                    <div class="icons d-flex">
                                        <button class="btn ml-2 p-0 kt_notes_panel_toggle" data-toggle="tooltip" title="" data-placement="right" data-original-title="Check out more demos" v-if="$parent.permissions.includes('product-collection-manage')">
                                            <span class="bg-secondary h-30px font-size-h5 w-30px d-flex align-items-center justify-content-center  rounded-circle shadow-sm " v-on:click="
                                                        display_form = !display_form
                                                    ">
                                                <svg width="25px" height="25px" viewBox="0 0 16 16" class="bi bi-plus white" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"></path>
                                                </svg>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 ">
                            <div class="card card-custom gutter-b bg-white border-0">
                                <div class="card-body">
                                    <div>
                                        <div class=" table-responsive" id="printableTable">

                                            <div id="productcollectionTable_wrapper" class="dataTables_wrapper no-footer">

                                                <div class="dataTables_length" id="productcollectionTable_length"><label>Показать
                                                        <select name="productcollectionTable_length"  class="" v-model="limit" v-on:change="fetchcollections()">
                                                            <option value="10">10</option>
                                                            <option value="25">25</option>
                                                            <option value="50">50</option>
                                                            <option value="100">100</option>
                                                            <option value="200">200</option>
                                                            <option value="500">500</option>
                                                            <option value="1000">1000</option>
                                                        </select> записей</label></div>

                                                <div id="productcollectionTable_filter" class="dataTables_filter">
                                                    <label>Поиск:<input type="text" class="" placeholder=""  v-model="searchParameter" @keyup="fetchcollections()"></label>
                                                    <button v-if="this.searchParameter != ''" @click="clearSearch">Очистить</button>
                                                </div>
                                                <table id="productcollectionTable" class="display dataTable no-footer" role="grid">
                                                    <thead class="text-body">
                                                        <tr role="row">
                                                            <th class="sorting" tabindex="0"  rowspan="1" colspan="1" aria-sort="ascending" aria-label="ID: activate to sort column descending" style="width: 48.9797px;" @click="sorting('id')" :class="(this.$data.sortType == 'asc' || this.$data.sortType == 'ASC') && this.$data.sortBy == 'id'  ? 'sorting_asc' : (this.$data.sortType == 'desc' || this.$data.sortType == 'DESC') && this.$data.sortBy == 'id' ? 'sorting_desc' : 'sorting'">
                                                                ID
                                                            </th>
                                                            <th class="sorting" tabindex="0"  rowspan="1" colspan="1" aria-label="collection: activate to sort column ascending" style="width: 113.2585px;" @click="sorting('name')" :class="(this.$data.sortType == 'asc' || this.$data.sortType == 'ASC') && this.$data.sortBy == 'name'  ? 'sorting_asc' : (this.$data.sortType == 'desc' || this.$data.sortType == 'DESC') && this.$data.sortBy == 'name' ? 'sorting_desc' : 'sorting'">
                                                                Название
                                                            </th>
                                                            <th class="no-sort sorting_disabled" rowspan="1" colspan="1" aria-label="Parent" style="width: 113.2585px;">
                                                                Родительская коллекция
                                                            </th>
                                                            <th class="sorting" tabindex="0"  rowspan="1" colspan="1" aria-label="Sort Order" style="width: 80px;" @click="sorting('sort_order')" :class="(this.$data.sortType == 'asc' || this.$data.sortType == 'ASC') && this.$data.sortBy == 'sort_order'  ? 'sorting_asc' : (this.$data.sortType == 'desc' || this.$data.sortType == 'DESC') && this.$data.sortBy == 'sort_order' ? 'sorting_desc' : 'sorting'">
                                                                Сортировка
                                                            </th>
                                                            <th class="no-sort sorting_disabled" rowspan="1" colspan="1" aria-label="Action" style="width: 70.9188px;">
                                                                Состояние
                                                            </th>
                                                            <th v-if="$parent.permissions.includes('product-collection-manage')" class="no-sort sorting_disabled" rowspan="1" colspan="1" aria-label="Action" style="width: 53.1891px;">
                                                                Действие
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="kt-table-tbody text-dark">
                                                        <tr class="kt-table-row kt-table-row-level-0 odd" role="row" v-for="collection in collections" v-bind:key="collection.id">
                                                            <td class="sorting_1">
                                                                {{collection.id}}
                                                            </td>
                                                            <td>
                                                                {{ getCollectionName(collection) }}
                                                            </td>
                                                            <td>
                                                                <span v-if="collection.parent">{{ collection.parent_full_path || getCollectionName(collection.parent) }}</span>
                                                                <span v-else class="text-muted">—</span>
                                                            </td>
                                                            <td>
                                                                {{ collection.sort_order }}
                                                            </td>
                                                            <td>
                                                                {{ collection.status }}
                                                            </td>
                                                            <td v-if="$parent.permissions.includes('product-collection-manage')">
                                                                <a href="javascript:void(0)" class=" click-edit" id="click-edit1" data-toggle="tooltip" title="" data-placement="right" data-original-title="Check out more demos" @click="editcollection(collection)"><i class="fa fa-edit"></i></a>
                                                                <a class="" href="#" @click="deletecollection(collection.id)"><i class="fa fa-trash"></i></a>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <ul class="pagination pagination-sm m-0 float-right">
                                                    <li v-bind:class="[{disabled: !pagination.prev_page_url}]"><button class="page-link" href="#" @click="fetchcollections(pagination.prev_page_url)">Предыдущая</button></li>

                                                    <li class="disabled">
                                                        <span class="page-link text-dark text-center" href="#">Стр {{ pagination.current_page }} из {{ pagination.last_page }}</span>
                                                        <span class="page-link text-dark">Перейти на <input style="width:25px;border:1px solid #dee2e6;text-align: center;" type="text" v-model="pagination.current_page" @keyup="changePage()" /></span>
                                                    </li>

                                                    <li v-bind:class="[{disabled: !pagination.next_page_url}]" class="page-item"><button class="page-link" href="#" @click="fetchcollections(pagination.next_page_url)">Следующая</button></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="offcanvas offcanvas-right kt-color-panel p-5 kt_notes_panel" v-if="display_form" :class="display_form ? 'offcanvas-on' : ''">
        <div class="offcanvas-header d-flex align-items-center justify-content-between pb-3">
            <h4 class="font-size-h4 font-weight-bold m-0" v-if="collection.id">Изменить коллекцию</h4>
            <h4 class="font-size-h4 font-weight-bold m-0" v-else>Добавить коллекцию</h4>
            <a href="#" class="btn btn-sm btn-icon btn-light btn-hover-primary kt_notes_panel_close" v-on:click="clearForm()">
                <svg width="20px" height="20px" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path>
                </svg>
            </a>
        </div>
        <form id="myform">
            <div class="row">
                <div class="col-12">
                    <div class="tabslang">
                        <div v-for="language in languages" class="tablang" :class="language.id == selectedLanguage ? 'active' : ''" @click="setSelectedLanguage(language.id)">
                            {{ language.language_name }}
                        </div>
                    </div>
                    <br />

                    <div class="form-group" v-for="(language, index) in languages" v-if="language.id == selectedLanguage">
                        <label class="text-dark">Название коллекции ( {{ language.language_name }} )</label>
                        <input type="text" :name="'collection_name'+index" v-model="collection.names[index]" class="form-control" />
                        <small class="form-text text-danger" v-if="errors.has('collection_name.'+index)" v-text="errors.get('collection_name.'+index)"></small>
                        <small class="form-text text-danger" v-if="errors.has('collection_name')" v-text="errors.get('collection_name')"></small>
                    </div>

                    <br />
                    <div class="form-group" v-for="(language, index) in languages" v-if="language.id == selectedLanguage">
                        <label class="text-dark">Описание ( {{ language.language_name }} )</label>
                        <vue-editor v-model="collection.descriptions[index]"></vue-editor>
                        <small class="form-text text-danger" v-if="errors.has('description.'+index)" v-text="errors.get('description.'+index)"></small>
                    </div>

                    <div class="form-group">
                        <label class="text-dark">Родительская коллекция</label>
                        <fieldset class="form-group mb-3">
                            <select class="js-example-basic-single js-states form-control bg-transparent" v-model='collection.parent_id'>
                                <option :value="null">Нет (корневая коллекция)</option>
                                <option v-for="col in availableParentCollections" :key="col.id" :value="col.id">
                                    {{ col.full_path || getCollectionName(col) }}
                                </option>
                            </select>
                            <small class="form-text text-danger" v-if="errors.has('parent_id')" v-text="errors.get('parent_id')"></small>
                        </fieldset>
                    </div>

                    <div class="form-group">
                        <label class="text-dark">Порядок сортировки</label>
                        <input type="number" v-model="collection.sort_order" class="form-control" min="0" />
                        <small class="form-text text-muted">Меньшее значение - выше в списке. По умолчанию: 0</small>
                        <small class="form-text text-danger" v-if="errors.has('sort_order')" v-text="errors.get('sort_order')"></small>
                    </div>

                    <!-- <div class="form-group">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="showOnHomeCheckbox" v-model="collection.show_on_home" true-value="1" false-value="0">
                            <label class="custom-control-label text-dark" for="showOnHomeCheckbox">
                                Показать баннер
                            </label>
                        </div>
                        <small class="form-text text-muted">Отображать коллекцию в слайдере на главной странице</small>
                        <small class="form-text text-danger" v-if="errors.has('show_on_home')" v-text="errors.get('show_on_home')"></small>
                    </div> -->

                    <div class="form-group">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="showInChildrenGridCheckbox" v-model="collection.show_in_children_grid" true-value="1" false-value="0">
                            <label class="custom-control-label text-dark" for="showInChildrenGridCheckbox">
                                Отображение на главной
                            </label>
                        </div>
                        <small class="form-text text-muted">Показывать эту коллекцию в сетке на главной странице</small>
                        <small class="form-text text-danger" v-if="errors.has('show_in_children_grid')" v-text="errors.get('show_in_children_grid')"></small>
                    </div>

                    <div class="form-group">
                        <label class="text-dark">Изображение коллекции</label>
                        <input id="collection-image" @change="handleCollectionImage" type="file" accept="image/*" style="display: none;">
                        <label for="collection-image" class="btn btn-light border-dashed d-block text-center" style="height: 100px; cursor: pointer; border: 2px dashed #dee2e6; display: flex; align-items: center; justify-content: center;">
                            <div v-if="collection_image_preview || collection.image_url" style="width: 100%; text-align: center;">
                                <img :src="collection_image_preview || collection.image_url" class="img-thumbnail" style="max-height: 80px; max-width: 100%;">
                            </div>
                            <div v-else class="text-muted">
                                <i class="fas fa-plus fa-2x"></i>
                                <div class="small mt-1">Нажмите для загрузки изображения</div>
                            </div>
                        </label>
                        <small class="form-text text-muted">Это изображение будет отображаться в плитке коллекции на главной странице</small>
                    </div>

                    <!-- Banners Management Section -->
                    <div class="form-group">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <label class="text-dark mb-0">Баннеры коллекции</label>
                            <button type="button" @click="addBanner" class="btn btn-sm btn-primary">
                                <i class="fas fa-plus"></i> Добавить баннер
                            </button>
                        </div>
                        <small class="form-text text-muted">Добавьте баннеры для отображения на главной странице</small>

                        <div v-if="collection.banners && collection.banners.length > 0" class="mt-3">
                            <div v-for="(banner, index) in collection.banners" :key="index" class="card mb-3">
                                <div class="card-body">
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <h6 class="mb-0">Баннер #{{ index + 1 }}</h6>
                                        <button type="button" @click="removeBanner(index)" class="btn btn-sm btn-danger">
                                            <i class="fas fa-trash"></i>
                                        </button>
                                    </div>
                                    <div class="form-group">
                                        <label class="text-dark">Изображение</label>
                                        <input :id="'banner-image-'+index" @change="(event) => handleBannerImage(event, index)" type="file" accept="image/*" style="display: none;">
                                        <label :for="'banner-image-'+index" class="btn btn-light border-dashed d-block text-center" style="height: 120px; cursor: pointer; border: 2px dashed #dee2e6; display: flex; align-items: center; justify-content: center;">
                                            <div v-if="banner.image_preview || banner.image_url || banner.image" :key="banner.image_preview || banner.image_url || banner.image" style="width: 100%; text-align: center;">
                                                <img :src="banner.image_preview || banner.image_url || banner.image" class="img-thumbnail" style="max-height: 100px; max-width: 100%;">
                                            </div>
                                            <div v-else class="text-muted">
                                                <i class="fas fa-plus fa-2x"></i>
                                                <div class="small mt-1">Нажмите для загрузки</div>
                                            </div>
                                        </label>
                                    </div>
                                    <div class="form-group">
                                        <label class="text-dark">Заголовок</label>
                                        <input type="text" v-model="banner.title" class="form-control" placeholder="Заголовок баннера">
                                    </div>
                                    <div class="form-group">
                                        <label class="text-dark">Подзаголовок</label>
                                        <input type="text" v-model="banner.subtitle" class="form-control" placeholder="Подзаголовок баннера">
                                    </div>
                                    <div class="form-group">
                                        <label class="text-dark">Позиция</label>
                                        <select v-model="banner.position" class="form-control">
                                            <option value="hero">Hero</option>
                                            <option value="hero-collection">Hero-collection</option>
                                            <option value="home-1">Home-1</option>
                                            <option value="home-2">Home-2</option>
                                            <option value="home-3">Home-3</option>
                                        </select>
                                        <small class="form-text text-muted">Выберите, где будет отображаться баннер</small>
                                    </div>
                                    <div class="form-group">
                                        <label class="text-dark">Порядок сортировки</label>
                                        <input type="number" v-model="banner.sort_order" class="form-control" min="0">
                                    </div>
                                    <div class="form-group">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input" :id="'banner-active-'+index" v-model="banner.is_active" true-value="1" false-value="0">
                                            <label class="custom-control-label" :for="'banner-active-'+index">Активен</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="text-muted mt-2">Нет добавленных баннеров</div>
                    </div>

                    <!-- Menu Images Management Section -->
                    <div class="form-group">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <label class="text-dark mb-0">Изображения для меню</label>
                            <button type="button" @click="addMenuImage" class="btn btn-sm btn-primary">
                                <i class="fas fa-plus"></i> Добавить изображение
                            </button>
                        </div>
                        <small class="form-text text-muted">Добавьте изображения для отображения в меню коллекции</small>

                        <div v-if="collection.menu_images && collection.menu_images.length > 0" class="mt-3">
                            <div v-for="(menuImage, index) in collection.menu_images" :key="index" class="card mb-3">
                                <div class="card-body">
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <h6 class="mb-0">Изображение #{{ index + 1 }}</h6>
                                        <button type="button" @click="removeMenuImage(index)" class="btn btn-sm btn-danger">
                                            <i class="fas fa-trash"></i>
                                        </button>
                                    </div>
                                    <div class="form-group">
                                        <label class="text-dark">Изображение</label>
                                        <input :id="'menu-image-'+index" @change="(event) => handleMenuImage(event, index)" type="file" accept="image/*" style="display: none;">
                                        <label :for="'menu-image-'+index" class="btn btn-light border-dashed d-block text-center" style="height: 100px; cursor: pointer; border: 2px dashed #dee2e6; display: flex; align-items: center; justify-content: center;">
                                            <div v-if="menuImage.image_preview || menuImage.image_url || menuImage.image" :key="menuImage.image_preview || menuImage.image_url || menuImage.image" style="width: 100%; text-align: center;">
                                                <img :src="menuImage.image_preview || menuImage.image_url || menuImage.image" class="img-thumbnail" style="max-height: 80px; max-width: 100%;">
                                            </div>
                                            <div v-else class="text-muted">
                                                <i class="fas fa-plus fa-2x"></i>
                                                <div class="small mt-1">Нажмите для загрузки</div>
                                            </div>
                                        </label>
                                    </div>
                                    <div class="form-group">
                                        <label class="text-dark">Название</label>
                                        <input type="text" v-model="menuImage.title" class="form-control" placeholder="Название для меню">
                                    </div>
                                    <div class="form-group">
                                        <label class="text-dark">Ссылка</label>
                                        <input type="text" v-model="menuImage.link" class="form-control" placeholder="Ссылка (например, /collection/1)">
                                    </div>
                                    <div class="form-group">
                                        <label class="text-dark">Порядок сортировки</label>
                                        <input type="number" v-model="menuImage.sort_order" class="form-control" min="0">
                                    </div>
                                    <div class="form-group">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input" :id="'menu-active-'+index" v-model="menuImage.is_active" true-value="1" false-value="0">
                                            <label class="custom-control-label" :for="'menu-active-'+index">Активен</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="text-muted mt-2">Нет добавленных изображений</div>
                    </div>

                    <div class="form-group">
                        <label>Состояние</label>
                        <fieldset class="form-group mb-3">
                            <select class="js-example-basic-single js-states form-control bg-transparent" v-model='collection.status' >
                                <option value="0">Выбрать состояние</option>
                                <option value="1">Активный</option>
                                <option value="0">Неактивный</option>
                            </select>
                            <small class="form-text text-danger" v-if="errors.has('status')" v-text="errors.get('status')"></small>
                        </fieldset>
                    </div>


                </div>
            </div>
            <button type="button" @click="addUpdatecollection()" class="btn btn-primary" style="position: absolute; right: 39px">Подтвердить</button>
        </form>
    </div>
</div>
</template>

<script>
import ErrorHandling from "../../ErrorHandling";
import { VueEditor } from "vue2-editor";

export default {
    components: {
        VueEditor
    },
    data() {
        return {
            display_form: 0,
            collection: {
                id: "",
                names: [],
                descriptions: [],
                language_id: [],
                status: "",
                parent_id: null,
                show_on_home: false,
                show_in_children_grid: false,
                sort_order: 0,
                is_b2b: 0,
                b2b_price_factor: 0,
                banners: [],
                menu_images: [],
            },
            collection_image: null,
            collection_image_preview: null,
            searchParameter: '',
            sortBy: 'sort_order',
            sortType: 'ASC',
            limit: 10,
            error_message: '',
            edit: false,
            actions: false,
            pagination: {},
            request_method: "",
            countrySelected: "",
            stateSelected: "",
            collections: [],
            allCollections: [],
            languages: [],
            token: [],
            selectedLanguage: '',
            errors: new ErrorHandling(),
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute("content")
        };
    },

    computed: {
        availableParentCollections() {
            return this.allCollections.filter(col => col.id !== this.collection.id);
        }
    },

    methods: {

        fetchLanguages() {
            this.$parent.loading = true;
            var token = localStorage.getItem('token');
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            };

            axios.get('/api/admin/language?limit=500', config)
                .then(res => {
                    if (res.data.status == "Success") {
                        this.languages = res.data.data;
                        for (var i = 0; i < res.data.data.length; i++) {
                            this.collection.language_id.push(res.data.data[i].id);
                            if (res.data.data[i].is_default) {
                                this.selectedLanguage = res.data.data[i].id;
                            }
                        }
                    }
                }).finally(() => (this.$parent.loading = false));
        },

        getCollectionName(collection) {
            if (collection.details && collection.details.length > 0) {
                return collection.details[0].collection_name || 'Collection';
            }
            return 'Collection';
        },

        getCollectionParentPath(collection) {
            if (!collection.parent) return '';
            // Use full_path from backend if available, otherwise build it
            if (collection.parent.full_path) {
                return collection.parent.full_path;
            }
            // Fallback: build path from current collection up to root
            var path = [];
            var current = collection;

            // First, build path from current collection up to root
            while (current) {
                if (current.details && current.details.length > 0) {
                    path.unshift(current.details[0].collection_name);
                }
                current = current.parent;
            }

            return path.join(' > ');
        },

        fetchAllCollections() {
            axios.get('/api/admin/collection?getAllData=1&limit=1000', this.token)
                .then(res => {
                    this.allCollections = res.data.data;
                })
                .catch(error => {
                    console.error('Error fetching all collections:', error);
                });
        },

        fetchcollections(page_url) {
            this.$parent.loading = true;
            let vm = this;
            page_url = page_url || "/api/admin/collection";
            var arr = page_url.split('?');

            if (arr.length > 1) {
                page_url += '&limit=' + this.limit;
            } else {
                page_url += '?limit=' + this.limit;
            }
            if (this.searchParameter != null) {
                page_url += '&searchParameter=' + this.searchParameter;
            }
            page_url += '&sortBy=' + this.sortBy + '&sortType=' + this.sortType + '&getDetail=1';
            var responseData = {};

            axios.get(page_url, this.token).then(res => {
                this.collections = res.data.data;
                vm.makePagination(res.data.meta, res.data.links);
            }).finally(() => (this.$parent.loading = false));
        },

        changePage(){
          if(this.timer){
              clearTimeout(this.timer);
          }
          this.timer = setTimeout(() => {
              if(this.pagination.current_page>this.pagination.last_page) {
                  this.pagination.current_page = this.pagination.last_page
              } else if(this.pagination.current_page<1 || isNaN(this.pagination.current_page)) {
                  this.pagination.current_page = 1
              }
              this.fetchcollections('/api/admin/collection?page='+this.pagination.current_page);
          }, 1000)
      },

        makePagination(meta, links) {
            let pagination = {
                current_page: meta.current_page,
                last_page: meta.last_page,
                next_page_url: links.next,
                prev_page_url: links.prev
            };

            this.pagination = pagination;
        },
        deletecollection(id) {
            if (confirm('Are You Sure?')) {
                this.$parent.loading = true;
                axios.delete(`/api/admin/collection/${id}`, this.token)
                    .then(res => {
                        if (res.data.status == "Success") {
                            this.$toaster.success('Settings has been updated successfully')
                            this.fetchcollections();
                        }

                    })
                    .catch(error =>{
                        if (error.response.status == 422) {
                            if(error.response.data.status == 'Error'){
                                this.$toaster.error(error.response.data.message)
                            }
                        }
                    })
                    .finally(() => (this.$parent.loading = false));
            }
        },
        addUpdatecollection() {
            this.$parent.loading = true;
            var url = '/api/admin/collection';
            if (this.edit === false) {
                // Add
                this.request_method = 'post'
            } else {
                // Update
                var url = '/api/admin/collection/' + this.collection.id;
                this.request_method = 'put'
            }

            // Check if any banner or collection has a file to upload - use FormData in that case
            var hasFiles = (this.collection.banners && this.collection.banners.some(b => b.image_file)) ||
                           (this.collection.menu_images && this.collection.menu_images.some(m => m.image_file)) ||
                           this.collection_image;

            if (hasFiles) {
                // Use FormData for file uploads
                var formData = new FormData();

                // Add _method for Laravel to recognize PUT/PATCH
                if (this.edit) {
                    formData.append('_method', 'PUT');
                }

                // Add simple fields first
                formData.append('collection_name', this.collection.names[0] || '');
                formData.append('status', this.collection.status || 1);
                formData.append('parent_id', this.collection.parent_id || '');
                formData.append('show_on_home', this.collection.show_on_home ? 1 : 0);
                formData.append('show_in_children_grid', this.collection.show_in_children_grid ? 1 : 0);
                formData.append('sort_order', this.collection.sort_order || 0);
                formData.append('is_b2b', this.collection.is_b2b || 0);
                formData.append('b2b_price_factor', this.collection.b2b_price_factor || 0);

                // Add detail array for multilanguage support
                for (var i = 0; i < this.collection.language_id.length; i++) {
                    formData.append(`detail[${i}][language_id]`, this.collection.language_id[i]);
                    var name = this.collection.names[i] || '';
                    formData.append(`detail[${i}][collection_name]`, name);
                    formData.append(`detail[${i}][description]`, this.collection.descriptions[i] || '');
                }

                // Add banners
                if (this.collection.banners && this.collection.banners.length > 0) {
                    this.collection.banners.forEach((banner, index) => {
                        if (banner.image_file) {
                            formData.append(`banners[${index}][image_file]`, banner.image_file);
                        }
                        formData.append(`banners[${index}][id]`, banner.id || '');
                        formData.append(`banners[${index}][image]`, banner.image || '');
                        formData.append(`banners[${index}][title]`, banner.title || '');
                        formData.append(`banners[${index}][subtitle]`, banner.subtitle || '');
                        formData.append(`banners[${index}][link]`, banner.link || '');
                        formData.append(`banners[${index}][sort_order]`, banner.sort_order || 0);
                        formData.append(`banners[${index}][is_active]`, banner.is_active || 1);
                        formData.append(`banners[${index}][position]`, banner.position || 'hero');
                    });
                }

                // Add menu images
                if (this.collection.menu_images && this.collection.menu_images.length > 0) {
                    this.collection.menu_images.forEach((menuImage, index) => {
                        if (menuImage.image_file) {
                            formData.append(`menu_images[${index}][image_file]`, menuImage.image_file);
                        }
                        formData.append(`menu_images[${index}][id]`, menuImage.id || '');
                        formData.append(`menu_images[${index}][image]`, menuImage.image || '');
                        formData.append(`menu_images[${index}][title]`, menuImage.title || '');
                        formData.append(`menu_images[${index}][link]`, menuImage.link || '');
                        formData.append(`menu_images[${index}][sort_order]`, menuImage.sort_order || 0);
                        formData.append(`menu_images[${index}][is_active]`, menuImage.is_active || 1);
                    });
                }

                // Add collection image if uploaded
                if (this.collection_image) {
                    formData.append('collection_image', this.collection_image);
                }

                // Use FormData config
                const formDataConfig = {
                    headers: {
                        ...this.token.headers,
                        // Don't set Content-Type - browser will set it with boundary
                    }
                };

                // Always use POST (Laravel will recognize _method)
                axios.post(url, formData, formDataConfig)
                .then(res => {
                    if (res.data.status == "Success") {
                        this.display_form = 0;
                        this.$toaster.success('Settings has been updated successfully')
                        this.clearForm();
                        this.fetchcollections();
                    } else {
                        this.$toaster.error(res.data.message)
                    }
                })
                .catch(error => {
                    this.error_message = '';
                    this.errors = new ErrorHandling();
                    if (error.response.status == 422) {
                        if (error.response.data.status == 'Error') {
                            this.error_message = error.response.data.message;
                        } else {
                            this.errors.record(error.response.data.errors);
                        }
                    }
                }).finally(() => (this.$parent.loading = false));
            } else {
                // No files - use JSON
                // Prepare detail array for multilanguage support
                var detail = [];
                for (var i = 0; i < this.collection.language_id.length; i++) {
                    detail.push({
                        language_id: this.collection.language_id[i],
                        collection_name: this.collection.names[i] || '',
                        description: this.collection.descriptions[i] || ''
                    });
                }

                axios[this.request_method](url, {
                        collection_name: this.collection.names[0] || '',
                        status: this.collection.status,
                        parent_id: this.collection.parent_id,
                        show_on_home: this.collection.show_on_home,
                        show_in_children_grid: this.collection.show_in_children_grid,
                        sort_order: this.collection.sort_order,
                        is_b2b: this.collection.is_b2b,
                        b2b_price_factor: this.collection.b2b_price_factor,
                        detail: detail,
                        banners: this.collection.banners || [],
                        menu_images: this.collection.menu_images || [],
                    }, this.token)
                    .then(res => {
                        if (res.data.status == "Success") {
                            this.display_form = 0;
                            this.$toaster.success('Settings has been updated successfully')
                            this.clearForm();
                            this.fetchcollections();
                        } else {
                            this.$toaster.error(res.data.message)
                        }
                    })
                    .catch(error => {
                        this.error_message = '';
                        this.errors = new ErrorHandling();
                        if (error.response.status == 422) {
                            if (error.response.data.status == 'Error') {
                                this.error_message = error.response.data.message;
                            } else {
                                this.errors.record(error.response.data.errors);
                            }
                        }
                    }).finally(() => (this.$parent.loading = false));
            }
        },
        editcollection(collection) {
            this.edit = true;
            this.display_form = 1;
            this.errors = new ErrorHandling();
            this.collection.id = collection.id;
            this.collection.names = [];
            this.collection.descriptions = [];
            this.collection.status = collection.status;
            this.collection.parent_id = collection.parent_id;
            this.collection.show_on_home = collection.show_on_home || 0;
            this.collection.show_in_children_grid = collection.show_in_children_grid || 0;
            this.collection.sort_order = collection.sort_order || 0;
            this.collection.is_b2b = collection.is_b2b;
            this.collection.b2b_price_factor = collection.b2b_price_factor;
            // Use Vue.set for reactive arrays
            this.$set(this.collection, 'banners', collection.banners || []);
            this.$set(this.collection, 'menu_images', collection.menu_images || []);
            // Set collection image
            this.$set(this.collection, 'image_url', collection.image_url || null);
            this.collection_image_preview = null;
            this.collection_image = null;

            // Load details for each language
            if (collection.details && collection.details.length > 0) {
                collection.details.forEach(detail => {
                    var langIndex = this.collection.language_id.indexOf(detail.language_id);
                    if (langIndex !== -1) {
                        this.collection.names[langIndex] = detail.collection_name;
                        this.collection.descriptions[langIndex] = detail.description || '';
                    }
                });
            }
        },
        clearForm() {
            this.edit = false;
            this.collection.id = null;
            this.collection.names = [];
            this.collection.descriptions = [];
            this.collection.parent_id = null;
            this.collection.show_on_home = false;
            this.collection.show_in_children_grid = false;
            this.collection.sort_order = 0;
            this.collection.banners = [];
            this.collection.menu_images = [];
            this.collection_image_preview = null;
            this.collection_image = null;
            this.$set(this.collection, 'image_url', null);
            this.display_form = 0;
            this.errors = new ErrorHandling();
            this.fetchAllCollections();
        },
        sorting(sortBy) {
            this.sortBy = sortBy;
            this.sortType = this.sortType == 'asc' || this.sortType == 'ASC' ? this.sortType = 'desc' : this.sortType = 'asc';
            this.fetchcollections();
        },
        setSelectedLanguage(selectedLanguage) {
            this.selectedLanguage = selectedLanguage;
            console.log("i am clicked", selectedLanguage)
        },
        addBanner() {
            if (!this.collection.banners) {
                this.collection.banners = [];
            }
            this.collection.banners.push({
                id: null,
                image: '',
                title: '',
                subtitle: '',
                link: '',
                sort_order: this.collection.banners.length,
                is_active: 1,
                position: 'hero-collection'
            });
        },
        removeBanner(index) {
            if (confirm('Удалить этот баннер?')) {
                this.collection.banners.splice(index, 1);
            }
        },
        handleBannerImage(event, index) {
            const file = event.target.files[0];
            if (!file) return;

            const banner = this.collection.banners[index];

            // Create a preview using Vue.set for reactivity
            const reader = new FileReader();
            reader.onload = (e) => {
                this.$set(this.collection.banners, index, {
                    ...banner,
                    image_preview: e.target.result,
                    image_file: file
                });
            };
            reader.readAsDataURL(file);
        },
        handleCollectionImage(event) {
            const file = event.target.files[0];
            if (!file) return;

            this.collection_image = file;

            // Create a preview
            const reader = new FileReader();
            reader.onload = (e) => {
                this.collection_image_preview = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        addMenuImage() {
            if (!this.collection.menu_images) {
                this.collection.menu_images = [];
            }
            this.collection.menu_images.push({
                id: null,
                image: '',
                title: '',
                link: '',
                sort_order: this.collection.menu_images.length,
                is_active: 1
            });
        },
        removeMenuImage(index) {
            if (confirm('Удалить это изображение?')) {
                this.collection.menu_images.splice(index, 1);
            }
        },
        handleMenuImage(event, index) {
            const file = event.target.files[0];
            if (!file) return;

            const menuImage = this.collection.menu_images[index];

            // Create a preview using Vue.set for reactivity
            const reader = new FileReader();
            reader.onload = (e) => {
                this.$set(this.collection.menu_images, index, {
                    ...menuImage,
                    image_preview: e.target.result,
                    image_file: file
                });
            };
            reader.readAsDataURL(file);
        },
        clearSearch(){
            this.searchParameter = "",
            this.fetchcollections();
        }
    },
    mounted() {

        var token = localStorage.getItem('token');
        this.token = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };
        this.fetchLanguages();
        this.fetchcollections();
        this.fetchAllCollections();
    }
};
</script>

<style scoped>
.border-dashed {
    border: 2px dashed #dee2e6 !important;
}
.border-dashed:hover {
    border-color: #007bff !important;
    background-color: #f8f9fa;
}
input[type="file"] {
    display: none;
}
.slide img:hover {
    opacity: 0.8;
}
.img-thumbnail:hover {
    opacity: 0.8;
}
.tabslang {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-bottom: 10px;
}
.tablang {
    padding: 8px 15px;
    cursor: pointer;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    background: #f8f9fa;
}
.tablang:hover {
    background: #e9ecef;
}
.tablang.active {
    background: #007bff;
    color: white;
    border-color: #007bff;
}
</style>